import React, { useState } from "react";
import { useEffect } from "react";
import {
  Card,
  CardBody,
  CardTitle,
  Button,
  CardSubtitle,
  Modal,
} from "reactstrap";

import { Colxx } from "../../components/common/CustomBootstrap";
import { toast } from "react-toastify";
import { getRatingReview } from "../../services/ProfileService";
import userImage from "../../../src/assets/img/profiles/user.png";
import ThumbnailImage from "../../../src/components/cards/ThumbnailImage";
import { useHistory } from "react-router-dom";
import { ProfileService } from "../../services/ProfileService";

const PeerRating = () => {
  const history = useHistory();
  const [modalRight, setModalRight] = useState(false);
  const [ispreferedEmail, setPreferedEmail] = useState(true);
  const [peerContactNumber, setPeerContactNumber] = useState("");
  const [selectionId, setSelectionId] = useState("");
  const [showPersonal, setShowPersonal] = useState(false);
  const [showEmployer, setShowEmployer] = useState(false);
  const [experiencesList, setExperiencesList] = useState([]);
  const [requestId, setRequestId] = useState("");
  const [peerRequestList, setPeerRequestList] = useState([]);

  const [workedSameTeam, setWorkedSameTeam] = useState(false);
  const [workedDiffTeams, setWorkedDiffTeams] = useState(false);
  const [youSupervisedPeer, setYouSupervisedPeer] = useState(false);
  const [b2bRelation, setB2bRelation] = useState(false);
  const [customerRelation, setCustomerRelation] = useState(false);
  const [peerSupervisedYou, setPeerSupervisedYou] = useState(false);
  const [mentoringOrTraining, setMentoringOrTraining] = useState(false);
  const [academicRelation, setAcademicRelation] = useState(false);
  const [personalRelation, setPersonalRelation] = useState(false);
  const [fetchData, setFetch] = useState(false);
  const [expId, setExpId] = useState("");

  const [inputField, setInputField] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    description: "",
  });

  useEffect(() => {
    setInputField((prevState) => ({
      ...prevState,
      description:
        " Can you please rate my skills ? I am using Teamanics, a new career platform that uses peer ratings of skills to match people to jobs.",
    }));
    getCandidateExperiences();
    getReviewDetails();
  }, [0]);

  const navigate = () => {
    const requestId = window.sessionStorage.getItem("request_id");
    history.push({
      pathname: "/prs",
      search: "?id=" + window.sessionStorage.getItem("request_id") + "accepted",
    });
  };
  const navigateReject = () => {
    const requestId = window.sessionStorage.getItem("request_id");
    history.push({
      pathname: "/rejectrating",
      search: "?id=" + window.sessionStorage.getItem("request_id") + "reject",
    });
  };

  const askPeerRating = () => {
    // setShowPeerRatingForm(true);
    setModalRight(true);
  };

  const inputsHandler = (e) => {
    const { name, value } = e.target;
    setInputField((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handlePreferContact = (event) => {
    if (event.target.value == "Email") {
      setPreferedEmail(true);
    } else {
      setPreferedEmail(false);
    }
  };

  const peerContactHandleChange = (event) => {
    const result = event.target.value.replace(/\D/g, "");
    setPeerContactNumber(result);
  };

  const handleSelectionChange = (e) => {
    setSelectionId(e.target.value);
    if (e.target.value == "personal") {
      setShowPersonal(true);
      setPersonalRelation(true);
      setShowEmployer(false);
      setExpId("");
    } else if (e.target.value == "") {
      setShowPersonal(false);
      setShowEmployer(false);
      setExpId("");
    } else {
      setShowPersonal(true);
      setShowEmployer(true);
      setExpId(e.target.value);
    }
  };

  const updateWorkedSameTeam = () => setWorkedSameTeam(!workedSameTeam);
  const updateworkedDiffTeams = () => setWorkedDiffTeams(!workedDiffTeams);
  const updateYouSupervisedPeer = () =>
    setYouSupervisedPeer(!youSupervisedPeer);
  const updatePeerSupervisedYou = () =>
    setPeerSupervisedYou(!peerSupervisedYou);
  const updateB2BRelation = () => setB2bRelation(!b2bRelation);
  const updateMentoringOrTraining = () =>
    setMentoringOrTraining(!mentoringOrTraining);
  const updateCustomerRelation = () => setCustomerRelation(!customerRelation);
  const updateAcademicRelation = () => setAcademicRelation(!academicRelation);

  const getCandidateExperiences = () => {
    ProfileService.getExperience().then((response) => {
      try {
        if (response.data !== null) {
          var experienceDetails = response.data;
          if (experienceDetails.exps != null) {
            response.data.exps.length > 0 &&
              response.data.exps.map((experience) => {
                const obj = {
                  key: experience.id,
                  value: experience.employer,
                };
                experiencesList.push(obj);
              });
          }
          setExperiencesList(experiencesList);
        }
      } catch (err) {
        console.error("getExperience" + JSON.stringify(err));
      }
    });
  };

  const getReviewDetails = () => {
    ProfileService.getRatingReview().then((response) => {
      try {
        var peerRatinhDetails = response.data;
        if (peerRatinhDetails != null) {
          setPeerRequestList(peerRatinhDetails.reqList);
        }
      } catch (err) {
        console.error("getRatingReview" + JSON.stringify(err));
      }
    });
  };

  const sendPeerRequest = (event) => {
    if (
      inputField.firstName == "" ||
      inputField.firstName == undefined ||
      inputField.firstName == null
    ) {
      toast.error("Enter first name");
      return;
    }

    if (
      inputField.lastName == "" ||
      inputField.lastName == undefined ||
      inputField.lastName == null
    ) {
      toast.error("Enter last name");
      return;
    }

    if (ispreferedEmail) {
      if (
        inputField.email == "" ||
        inputField.email == undefined ||
        inputField.email == null
      ) {
        toast.error("Enter email");
        return;
      }
    } else {
      if (
        peerContactNumber == "" ||
        peerContactNumber == undefined ||
        peerContactNumber == null
      ) {
        toast.error("Enter phone number");
        return;
      }
    }

    if (selectionId == 0) {
      toast.error("Please select how do you know this person");
      return;
    }

    const peerRequest = {
      firstName: inputField.firstName,
      lastName: inputField.lastName,
      email: inputField.email,
      contactNumber: peerContactNumber,
      workedSameTeam: workedSameTeam,
      youSupervisedPeer: youSupervisedPeer,
      b2bRelation: b2bRelation,
      customerRelation: customerRelation,
      workedDiffTeams: workedDiffTeams,
      peerSupervisedYou: peerSupervisedYou,
      mentoringOrTraining: mentoringOrTraining,
      academicRelation: academicRelation,
      personalMessage: inputField.description,
      personalRelation: personalRelation,
      expId: expId,
    };

    if (requestId == "") {
      ProfileService.addPeerRating(peerRequest).then((response) => {
        try {
          toast.success("Peer request added successfully");
          window.sessionStorage.setItem("request_id", response.data.id);
          setInputField((prevState) => ({
            ...prevState,
            firstName: "",
            lastName: "",
            email: "",
          }));
          setPeerContactNumber("");
          getReviewDetails();
        } catch (err) {
          console.error("addPeerRating" + JSON.stringify(err));
        }
      });
    } else {
      ProfileService.updatePeerRating(peerRequest, requestId).then(
        (response) => {
          try {
            toast.success("Peer request updated successfully");
            setInputField((prevState) => ({
              ...prevState,
              firstName: "",
              lastName: "",
              email: "",
            }));
            setPeerContactNumber("");
            getReviewDetails();
          } catch (err) {
            console.error("updatePeerRating" + JSON.stringify(err));
          }
        }
      );
    }
  };

  const onInvitePeers = (peerRequest) => {
    setRequestId(peerRequest.id);
    setInputField((prevState) => ({
      ...prevState,
      firstName: peerRequest.firstName,
      lastName: peerRequest.lastName,
      email: peerRequest.email,
    }));
    setPeerContactNumber(peerRequest.contactNumber);
    // setShowPeerRatingForm(true);
    setWorkedSameTeam(peerRequest.workedSameTeam);
    setWorkedDiffTeams(peerRequest.workedDiffTeams);
    setYouSupervisedPeer(peerRequest.youSupervisedPeer);
    setPeerSupervisedYou(peerRequest.peerSupervisedYou);
    setB2bRelation(peerRequest.b2bRelation);
    setMentoringOrTraining(peerRequest.mentoringOrTraining);
    setCustomerRelation(peerRequest.customerRelation);
    setAcademicRelation(peerRequest.academicRelation);
  };

  const clearFormData = () => {
    setExpId("");
    setInputField((prevState) => ({
      ...prevState,
      firstName: "",
      lastName: "",
      email: "",
    }));
    setPeerContactNumber("");
    setModalRight(false);
    // setShowPeerRatingForm(false);
    setWorkedSameTeam(false);
    setWorkedDiffTeams(false);
    setYouSupervisedPeer(false);
    setPeerSupervisedYou(false);
    setB2bRelation(false);
    setMentoringOrTraining(false);
    setCustomerRelation(false);
    setAcademicRelation(false);
    setRequestId("");
  };

  return (
    <div className="Container-box">
      <div className="row">
        <div className="col-sm-12">
          <div className="barmenu_content">
            <div className="skill-header">
              <div>
                <div className="profile-card-title">
                  <label>
                    <h2>Peer Rating</h2>
                  </label>
                </div>
              </div>
              <div>
                <Button color="primary" outline onClick={askPeerRating}>
                  Ask Peer Rating123
                </Button>
              </div>
            </div>

            <Modal
              isOpen={modalRight}
              toggle={() => setModalRight(!modalRight)}
              wrapClassName="modal-right"
            >
              <Card>
                <CardBody>dfghjkjhgfdsxdf</CardBody>
              </Card>
            </Modal>
            <div>
              {peerRequestList.length > 0 && (
                <div className="mt-5">
                  <Colxx md="12" sm="12" lg="12" xxs="12">
                    {peerRequestList.map((peerRequest) => {
                      return (
                        <Card className="d-flex flex-row mb-4">
                          <div className="d-flex">
                            <ThumbnailImage
                              rounded
                              src={userImage}
                              alt="Card image cap"
                              className="m-4"
                            />
                          </div>
                          <div className=" d-flex flex-grow-1 min-width-zero">
                            <CardBody className=" pl-0 align-self-center d-flex flex-column flex-lg-row justify-content-between min-width-zero">
                              <Colxx sm={8}>
                                <CardTitle className="truncate mb-1">
                                  {peerRequest.firstName +
                                    " " +
                                    peerRequest.lastName}
                                </CardTitle>

                                {peerRequest.email != null && (
                                  <CardSubtitle className="truncate mb-1">
                                    <i className="iconsminds-envelope review-icon"></i>
                                    {peerRequest.email}
                                  </CardSubtitle>
                                )}
                                {peerRequest.contactNumber != null && (
                                  <CardSubtitle className="truncate mb-1">
                                    <i className="simple-icon-phone  review-icon"></i>
                                    {peerRequest.contactNumber}
                                  </CardSubtitle>
                                )}
                              </Colxx>
                              <Colxx sm={4} className="justify-content-end">
                                <CardSubtitle className="truncate mb-1">
                                  <Button
                                    color="primary"
                                    size="xs"
                                    onClick={() => {
                                      onInvitePeers(peerRequest);
                                    }}
                                  >
                                    Invite to rate me
                                  </Button>
                                </CardSubtitle>
                              </Colxx>
                            </CardBody>
                          </div>
                        </Card>
                      );
                    })}
                  </Colxx>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PeerRating;
